// extracted by mini-css-extract-plugin
export default {"primaryColor":"#505f85","primaryColorLight":"#c5cbdc","secondaryColor":"#5e997a","secondaryColorLight":"#dae9e1"};